import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.any.isRequired
};

class TopPanelPortal extends React.Component {
  constructor() {
    super();
    this.node = null;
  }

  componentDidMount() {
    this.node = document.getElementById('top-panel-portal');
    if(this.node) this.forceUpdate();
  }

  render() {
    const { children } = this.props;

    if(!this.node) return null;
    return createPortal(children, this.node);
  }
}

TopPanelPortal.propTypes = propTypes;

export default TopPanelPortal;


// WEBPACK FOOTER //
// ./src/components/TopPanelPortal.jsx